<template>
  <div
    :class=" [scrollTop < -192 && scrollTop > -1600? 'on':'no']"
    class="vip-fixed-header"
  >
    <div class="inner_center">
      <div class="authorized-scope">
        授权范围
      </div>
      <div class="member-package-item">
        <div class="package-business package-item">
          <div class="title">
            <div class="name">{{ PERSON.INFO.LABEL }}</div>
            <div class="price __price-wrap">
              <span class="text-dollar">￥</span>
              <span class="text-price">{{ PERSON.MONTH.PRICE }}</span>
              <span class="text-year">/月起</span>
            </div>
            <div
              class="buy-btn"
              @click="buy(PERSON.MONTH)">立即开通
            </div>
          </div>
        </div>
        <div class="package-business  package-item _hide">
          <div class="title">
            <div class="name">{{ BUSINESS_VIP_MONTH_INFO.NAME }}</div>
            <div class="price __price-wrap">
              <span class="text-dollar">￥</span>
              <span class="text-price">{{ BUSINESS_VIP_MONTH_INFO.PRICE }}</span>
              <span class="text-year">/月起</span>
            </div>
            <div class="buy-btn" @click="buy(BUSINESS_VIP_MONTH_INFO)">立即开通</div>
          </div>
        </div>
        <div class="package-company package-item">
          <div class="title">
            <div class="name">{{ COMPANY_All_PURPOSE.NAME }}</div>
            <div class="price __price-wrap">
              <span class="text-dollar">￥</span>
              <span class="text-price">{{ COMPANY_All_PURPOSE.PRICE }}</span>
              <span class="text-year">/年起</span>
            </div>
            <div class="buy-btn" @click="buy(COMPANY_All_PURPOSE)">立即开通</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BUSINESS_VIP_INFO, PERSON_VIP_INFO,
  PERSON_QUARTER_MONTH_INFO, BUSINESS_VIP_MONTH_INFO, PERSON_QUARTER_INFO
} from "@/constant/VIP";
import {info} from "~/components/member/common/module";
import {COMPANY_ONLINE,COMPANY_All_PURPOSE} from "@/constant/VIP_COMPANY";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

const {PERSON} = VIP_MANAGE
export default {
  name: "VipFixedHeader",
  data() {
    return {
      info,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO,PERSON_QUARTER_INFO,
      PERSON_QUARTER_MONTH_INFO,
      BUSINESS_VIP_MONTH_INFO,
      isShow: false,
      COMPANY_ONLINE,
      COMPANY_All_PURPOSE,
      PERSON
    }
  },
  props: {
    scrollTop: {
      type: String | Number,
      default: 0
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    },
  }
}
</script>

<style lang="scss" scoped>

.vip-fixed-header {
  position: fixed;
  width: 1200px !important;
  overflow: hidden;
  box-sizing: border-box;
  top: 76px;
  left: 50%;
  transform: translateX(-50%);
  height: 128px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 26, 0.06);
  z-index: 9;
  background-color: #fff;
  border: 1px solid #ECEFF6;
  transition: all 0.5s ease-in-out;

  &.on{
    top: 76px;
  }
  &.no{
    top: -200px;
  }

  .inner_center {
    display: flex;
  }

  .authorized-scope {
    width: 643px;
    box-sizing: border-box;
    line-height: 128px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #424866;
    border-right: 1px solid #ECEFF6;
  }
}


.member-package-item {
  height: 100%;
  flex: 1;
  display: flex;
  background-color: #fff;
  border-radius: 20px 20px 0px 0px;

  .package-item {
    //flex: 1;
    width: 279px;
    box-sizing: border-box;
    height: 100%;

    .title {
      height: 128px;
      box-sizing: border-box;
      //border-bottom: 1px solid #ECEFF6;
      border-right: 1px solid #ECEFF6;
      position: relative;
      padding: 18px 0 17px;
      @include LayoutFlex(2);

      .icon-prefs {
        @include Position(1, 5, 0, 0);
        width: 124px;
        height: 28px;
        background: linear-gradient(90deg, #FFD16C 0%, #FFAD63 100%);
        border-radius: 20px 0px 8px 0px;
        color: #FFFFFF;
        line-height: 28px;
        display: flex;
        align-items: center;
        font-size: 0;

        .icon_prefs {
          @include BgImage(15px, 15px, 'member/icon_prefs.png');
          margin: 0 4px 0 15px;

        }

        .icon-prefs-txt {
          font-size: 13px;
        }
      }

      .name {
        font-size: 16px;
        font-weight: bold;
        color: #35D0BA;
        line-height: 21px;
      }

      .__price-wrap {
        font-size: 0;
        margin: 3px 0 5px 0;
        color: #596088;
        font-weight: bold;

        .text-dollar {
          vertical-align: 2px;
          font-size: 14px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 19px;

        }

        .text-price {
          //letter-spacing: 1px;
          margin: 0 2px 0 0;
          font-size: 30px;
          font-weight: bold;
          color: #2D2B33;
          height: 32px;
          line-height: 32px;
        }

        .text-year {
          font-size: 14px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 22px;
        }
      }

      .buy-btn {
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease-in;
        width: 132px;
        height: 32px;
        background: #35D0BA;
        border-radius: 28px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 32px;
        letter-spacing: 1px;
      }

    }

    ul {
      border-right: 1px solid #ECEFF6;

      li {
        height: 80px;
        box-sizing: border-box;
        border-bottom: 1px solid #ECEFF6;
        @include LayoutFlex(1);

        .iconfont {
          font-size: 24px;
        }

        .icon-gou {
          color: #35D0BA;
        }

        .icon-cha2 {
          color: #A4A9BE;
        }

        &:last-child {
          border-bottom: 0;
        }

        span {
          font-size: 15px;
          color: #2D2B33;
          line-height: 20px;
        }
      }
    }

    &:first-child {
      ul {
        li {
          //border-right: 1px solid #ECEFF6;
        }
      }
    }

    &:last-child {
      .title {
        border-right: 0;
        //width: 261px;
        //background-color: #FFFFFF;
        position: relative;

        &:after {
          /*content: '';
          width: 10px;
          @include Position(1, 2, -1px, 0);
          bottom: 0;
          background-color: #FFFFFF;
          border-radius: 20px 20px 0px 0px;*/
        }
      }
    }

  }


  .package-business {
    .title {
      .name {
        color: #6969FF;
      }

      .buy-btn {
        background: #6969FF;
        color: #FFFFFF;
        @include ElementHover('', #5E5EE8);


      }
    }
  }

  .package-person {
    .title {
      .name {
        color: #35D0BA;
      }

      .buy-btn {
        color: #FFFFFF;
        //border: 1px solid #6969FF;
        @include ElementHover(#fff, #53D7C4);
      }
    }
  }

  .package-company {

    .title {
      .name {
        color: #233E90;
      }

      .buy-btn {
        color: #FFE198;
        background-color: #233E90;
        //border: 1px solid #6969FF;
        @include ElementHover(#FFE198, #435AA0);
      }

      .price {
        width: 100%;
        text-align: center;
        //margin: 4px auto;

        .text-price {
          //font-size: 22px;
          //font-weight: bold;
          //color: #424866;
          //line-height: 30px;
        }
      }
    }
  }
}
</style>
